import { LiaWalletSolid } from 'react-icons/lia';
import { ReactComponent as TetherIcon } from '@/assets/profile/tether.svg';
import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import config from '@/common/config';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import React from 'react';
import useWalletBalance from '@/hooks/useWalletBalance';
import { formatCurrency } from '@/pages/table/utils/utils';

const WalletBalance = () => {
  const { walletAddress, isLoading: isLoadingWallet } = useWalletAddress();

  const { data: usdtBalance, isLoading } = useWalletBalance(walletAddress, config.contracts.usdt);

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="w-full rounded-full bg-phenom-border-glow p-[2px]">
        <div className="flex h-11 w-full items-center justify-center gap-3 rounded-full bg-ph-violet-dark align-middle">
          <LiaWalletSolid size={20} className="text-ph-gray-evening" />

          <div className="flex items-center gap-1">
            {isLoadingWallet || isLoading ? (
              <LoadingSpinner size="4" />
            ) : (
              <span className="text-base font-semibold text-ph-gray-white">
                {usdtBalance ? formatCurrency(Number(usdtBalance.displayBalance)) : '-'}
              </span>
            )}
            <TetherIcon className="h-[22px] w-[22px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletBalance;
